export default {
  async get (data) {
    const q = data.text,
      lang_to = data['language-to'],
      lang_from = data['language-from'] || 'auto';
    const r = await fetch(`https://translate.googleapis.com/translate_a/single?client=dict-chrome-ex&sl=${lang_from}&tl=${lang_to}&hl=${lang_to}&dt=t&q=${q}`).then((r) => r.json())
    return `Tradução: <strong>${r[0][0][0]}</strong>`
  }
};
